export enum GLOBAL {
    ABORTED = 'GLOBAL.ABORTED',
    ABOUT = 'ABOUT',
    ACCEPT = 'GLOBAL.ACCEPT',
    ACCEPTED = 'CALENDAR.EVENT_STATUS_ACCEPTED_ARIA_LABEL',
    ACCESS = 'ACCESS',
    ACCESS_PREVIOUS_PAGE = 'ADMIN.GROUP.ACCESS_PREVIOUS_PAGE',
    ACCESS_REQUEST = 'ACCESS_REQUEST',
    ACCESS_REQUESTS = 'ACCESS_REQUESTS',
    ACHIEVEMENTS = 'SOCIAL_PROFILE_ACHIEVEMENTS',
    ACKNOWLEDGED = 'GLOBAL.ACKNOWLEDGED',
    ACTIONS = 'GLOBAL.ACTIONS',
    ACTION_NOT_COMPLETED_TRY_AGAIN = 'GLOBAL.ACTION_NOT_COMPLETED_TRY_AGAIN',
    ACTIVATE = 'GLOBAL.ACTIVATE',
    ACTIVATED = 'GLOBAL.ACTIVATED',
    ACTIVATION = 'GLOBAL.ACTIVATION',
    ACTIVATIONS = 'GLOBAL.ACTIVATIONS',
    ACTIVE = 'ACTIVE',
    ACTIVE_FILTERS = 'GLOBAL.ACTIVE_FILTERS',
    ACTIVITIES = 'EMOJI_PICKER.CATEGORY_ACTIVITIES',
    ACTIVITY = 'GLOBAL.ACTIVITY',
    ADD = 'GLOBAL.ADD',
    ADD_ALT_TEXT = 'WREX_IMAGE.INSERT_ALT_TEXT_ADD',
    ADD_A_COMMENT = 'FRONT.COMMENTS.ADD_A_COMMENT',
    ADD_A_MESSAGE = 'GLOBAL.ADD_A_MESSAGE',
    ADD_A_STRING = 'GLOBAL.ADD_A_STRING',
    ADD_DESCRIPTION = 'ASK_LUMAPPS_CONCEPTS.DESCRIPTION_FIELD_PLACEHOLDER',
    ADD_FEATURED_IMAGE = 'WREX_AI.ADD_FEATURED_IMAGE',
    ADD_GROUPS = 'GLOBAL.ADD_GROUPS',
    ADD_HERE = 'GLOBAL.ADD_HERE',
    ADD_LANGUAGE = 'GLOBAL.ADD_LANGUAGE',
    ADD_NAME = 'CONNECTORS.PLACEHOLDER_ADD_NAME',
    ADD_PHOTO = 'FRONT.SOCIAL_ADVOCACY.SHAREABLE_WORKFLOW.ADD_PHOTO',
    ADD_PHOTOS = 'FRONT.SOCIAL_ADVOCACY.SHAREABLE_WORKFLOW.ADD_PHOTOS',
    ADD_SITES = 'GLOBAL.ADD_SITES',
    ADD_SOURCE = 'SEARCH_SETTINGS.ADD_SOURCE',
    ADD_USERS = 'GLOBAL.ADD_USERS',
    ADD_VERSION = 'LANGUAGES.ADD_VERSION',
    ADD_VIDEO = 'GLOBAL.ADD_VIDEO',
    ADMINISTRATORS = 'ADMIN.NAV.INSTANCE_ADMINS',
    ADVANCED = 'GLOBAL.ADVANCED',
    ADVANCED_MEMBER = 'GLOBAL.ROLE_ADVANCED_MEMBER',
    ADVANCED_SETTINGS = 'ADMIN.NAV.CUSTOMER_ADVANCED_SETTINGS',
    AFTER = 'GLOBAL.AFTER',
    AGENTS = 'GLOBAL.AGENTS',
    AGENT_HUB = 'GLOBAL.AGENT_HUB',
    AGREE = 'GLOBAL.AGREE_ACTION',
    AI_DISCLAIMER = 'GLOBAL.AI_DISCLAIMER',
    AI_GENERATED_RESULT = 'WREX_AI.GENERATED_RESULT',
    ALL = 'GLOBAL.ALL',
    ALL_SITES = 'SOCIAL_PROFILE_FILTER_PLATFORM',
    ALL_TIME = 'GLOBAL.ALL_TIME',
    ALL_USERS = 'GLOBAL.ALL_USERS',
    ALPHABETICAL_ORDER = 'ADMIN.FOLKSONOMY.FILTER.ALPHA_ASC',
    ALPHABETICAL_ORDER_DESC = 'ADMIN.FOLKSONOMY.FILTER.ALPHA_DESC',
    ALREADY_ADDED = 'GLOBAL.ALREADY_ADDED',
    ALREADY_USED = 'GLOBAL.ALREADY_USED',
    ALREADY_USED_VALUE = 'GLOBAL.ALREADY_USED_VALUE',
    ANALYTICS = 'GLOBAL.ANALYTICS',
    ANALYTICS_DASHBOARDS = 'GLOBAL.ANALYTICS_DASHBOARDS',
    ANALYZING_FILE = 'GLOBAL.ANALYZING_FILE',
    AND = 'GLOBAL.AND',
    ANSWER = 'GLOBAL.ANSWER',
    ANSWERS_GENERATED_BY_AI = 'GLOBAL.ANSWERS_GENERATED_BY_AI',
    ANYTIME = 'PLAY.SINCE_ANY_TIME',
    APP = 'GLOBAL.APP',
    APPLICATION_NAME = 'MOBILE_BRANDED_APPS.APPLICATION_NAME_LABEL',
    APPLIES_TO = 'GLOBAL.APPLIES_TO',
    APPLY = 'APPLY',
    APPLY_CHANGES = 'GLOBAL.APPLY_CHANGES',
    APPLY_FILTERS = 'GLOBAL.APPLY_FILTERS',
    APPROXIMATELY = 'GLOBAL.APPROXIMATELY',
    APP_LOGO = 'GLOBAL.APP_LOGO',
    ARCHIVABLE = 'CAN_PAGE_ARCHIVE',
    ARCHIVE = 'ARCHIVE',
    ARCHIVED = 'GLOBAL.ARCHIVED',
    ARTICLE = 'GLOBAL.ARTICLE',
    ARTICLES = 'COMMUNITY_SETTINGS.ARTICLE_SERVICE_TITLE',
    ASCENDING = 'FRONT.SETTINGS.ASCENDING_SORT_ORDER',
    ASK_AI = 'GLOBAL.ASK_AI',
    ASK_QUESTION_OR_SEARCH = 'ASK_AI.ASK_QUESTION_OR_SEARCH',
    AT = 'GLOBAL.AT',
    ATTACH = 'GLOBAL.ATTACH',
    ATTACHMENT = 'JOURNEYS_CORE.ATTACHMENT',
    ATTENDANCE_STATUS = 'GLOBAL.ATTENDANCE_STATUS',
    ATTENDED = 'GLOBAL.ATTENDED',
    AUDIENCE = 'GLOBAL.AUDIENCE',
    AUTHOR = 'GLOBAL.AUTHOR',
    AUTHORIZATION_CODE = 'CONNECTORS.AUTHORIZATION_CODE',
    AUTHORIZATION_URL = 'CONNECTORS.AUTHORIZATION_URI',
    AUTHORIZATION_URL_HELPER = 'CONNECTORS.AUTHORIZATION_URI_HELPER',
    AUTOTRANSLATE = 'DESIGNER_TRANSLATIONS.AUTOTRANSLATE',
    AVAILABILITY = 'GLOBAL.AVAILABILITY',
    AVAILABLE_IN = 'GLOBAL.AVAILABLE_IN',
    AVATAR = 'GLOBAL.AVATAR',
    A_OR_B = 'GLOBAL.A_OR_B',
    BACK = 'GLOBAL.BACK',
    BACKGROUND = 'STYLE.BACKGROUND',
    BACKGROUND_COLOR = 'STYLE.BACKGROUND_COLOR',
    BACK_TO_CURRENT_VERSION = 'GLOBAL.BACK_TO_CURRENT_VERSION',
    BACK_TO_DRAFT = 'GLOBAL.BACK_TO_DRAFT',
    BACK_TO_HOME = 'GLOBAL.BACK_TO_HOME',
    BASIC = 'GLOBAL.BASIC',
    BEEKEEPER = 'IDENTITY_PROVIDER.BEEKEEPER',
    BEFORE = 'GLOBAL.BEFORE',
    BETA = 'GLOBAL.BETA',
    BODY = 'CONNECTORS.CREDENTIALS.BODY',
    BOOKMARKED_APPS = 'GLOBAL.BOOKMARKED_APPS',
    BREADCRUMB = 'GLOBAL.BREADCRUMB',
    BROADCAST = 'GLOBAL.BROADCAST',
    BY = 'BY',
    BY_VALUE = 'GLOBAL.BY_VALUE',
    BY_VALUE_ON_BEHALF = 'GLOBAL.BY_VALUE_ON_BEHALF',
    CALENDAR = 'GLOBAL.CALENDAR',
    CANCEL = 'GLOBAL.CANCEL',
    CAPTURE = 'GLOBAL.CAPTURE',
    CAROUSEL = 'GLOBAL.CAROUSEL',
    CATALOG = 'GLOBAL.CATALOG',
    CATEGORIES = 'WIDGET_POST_LIST.CATEGORIES',
    CATEGORY = 'GLOBAL.CATEGORY',
    CHALLENGE = 'GLOBAL.CHALLENGE',
    CHANGE = 'PAGE.REVIEW.CHANGE',
    CHANGES_CHANGED = 'GLOBAL.CHANGES_CHANGED',
    CHANGES_NOT_SAVED = 'GLOBAL.CHANGES_NOT_SAVED',
    CHAT = 'BOOKMARKED_APPS_CHAT',
    CHATS = 'GLOBAL.CHATS',
    CHECK_STATUS = 'ADMIN.CUSTOMER.HOOKS.CHECK_STATUS',
    CHOOSE_A_DATE = 'GLOBAL.CHOOSE_A_DATE',
    CLEAR = 'GLOBAL.CLEAR',
    CLEAR_ALL = 'REPORTS.CLEAR_ALL',
    CLEAR_ALL_FILTERS = 'GLOBAL.CLEAR_ALL_FILTERS',
    CLEAR_FILTER = 'GLOBAL.CLEAR_FILTER',
    CLEAR_SEARCH = 'GLOBAL.CLEAR_SEARCH',
    CLIENT_CREDENTIALS = 'CONNECTORS.CLIENT_CREDENTIALS_NEW',
    CLIENT_ID = 'CONNECTORS.CLIENT_ID',
    CLIENT_ID_HELPER = 'CONNECTORS.CLIENT_ID_HELPER',
    CLIENT_SECRET = 'CONNECTORS.CLIENT_SECRET',
    CLIENT_SECRET_HELPER = 'CONNECTORS.CLIENT_SECRET_HELPER',
    CLOSE = 'GLOBAL.CLOSE',
    CLOUDSEARCH = 'GLOBAL.CLOUDSEARCH',
    COLLAPSE = 'GLOBAL.COLLAPSE',
    COLLAPSED = 'GLOBAL.COLLAPSED',
    COLOR = 'STYLE.COLOR',
    COMMENT = 'COMMENT_BUTTON_LABEL',
    COMMENTS = 'COMMENT_BUTTON_LABEL_PLURAL',
    COMMENT_PLURALIZE = 'GLOBAL.COMMENT_PLURALIZE',
    COMMUNITIES = 'ADMIN.NAV.COMMUNITIES',
    COMMUNITY = 'GLOBAL.COMMUNITY',
    COMPLETED = 'GLOBAL.COMPLETED',
    COMPLETED_TRANSLATIONS = 'LANGUAGES.COMPLETED_TRANSLATIONS',
    COMPLETION = 'GLOBAL.COMPLETION',
    CONDITIONS = 'GLOBAL.CONDITIONS',
    CONFIGURATION = 'GLOBAL.CONFIGURATION',
    CONFIRM = 'GLOBAL.CONFIRM',
    CONFIRM_CLOSE = 'GLOBAL.PICKER_DIALOG.CONFIRM_CLOSE_TITLE',
    CONFIRM_CLOSE_DESCRIPTION = 'GLOBAL.PICKER_DIALOG.CONFIRM_CLOSE_DESCRIPTION',
    CONFIRM_SOURCE_LANGUAGE = 'LANGUAGES.CONFIRM_SOURCE_LANGUAGE',
    /**
     * @todo: CHANGE THE KEY TO GLOBAL.CONNECT
     */
    CONNECT = 'ADMIN.SEARCH_SETTINGS.CONNECTION_SUBMIT',
    /**
     * @todo: CHANGE THE KEY TO GLOBAL.CONNECTED
     */
    CONNECTED = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM_CONNECTED',
    CONNECTED_AS = 'GLOBAL.CONNECTED_AS',
    CONNECTION = 'GLOBAL.CONNECTION',
    CONNECTIONS = 'GLOBAL.CONNECTIONS',
    CONNECTION_REQUIRED = 'GLOBAL.CONNECTION_REQUIRED',
    CONNECTORS = 'GLOBAL.CONNECTORS',
    CONTACT_EMAIL = 'ADMIN_CUSTOMER_CONTACT_EMAIL',
    CONTENT = 'GLOBAL.CONTENT',
    CONTENTS = 'GLOBAL.CONTENTS',
    CONTENTS_IN_CONTAINER = 'GLOBAL.CONTENTS_IN_CONTAINER',
    CONTENT_HIDDEN = 'GLOBAL.CONTENT_HIDDEN',
    CONTENT_LIST = 'GLOBAL.CONTENT_LIST',
    CONTENT_STREAM = 'MOBILE.HOME_PAGE_SECTION_CONTENT_STREAM_TITLE',
    CONTENT_TYPE = 'CONTENT_TYPE_CUSTOM',
    CONTENT_TYPES = 'GLOBAL.CONTENT_TYPES',
    CONTEXTUAL_ACTIONS_MENU = 'GLOBAL.CONTEXTUAL_ACTIONS_MENU',
    CONTINUE = 'GLOBAL.CONTINUE',
    CONTINUE_EDITING = 'GLOBAL.CONTINUE_EDITING',
    CONTINUE_IN_BROWSER = 'GLOBAL.CONTINUE_IN_BROWSER',
    COPIED = 'GLOBAL.COPIED',
    COPY = 'GLOBAL.COPY',
    COPY_LINK = 'GLOBAL.COPY_LINK',
    COUNT_IMPRESSION = 'GLOBAL.COUNT_IMPRESSION',
    COURSE = 'GLOBAL.COURSE',
    COVEO = 'GLOBAL.COVEO',
    COVER = 'GLOBAL.COVER',
    CREATE = 'GLOBAL.CREATE',
    CREATED = 'GLOBAL.CREATED',
    CREATED_AT = 'CREATED_AT',
    CREATED_BY = 'CREATED_BY',
    CREATED_DATE = 'CREATED_DATE',
    CREATED_ON = 'ADMIN.FOLKSONOMY.CREATED_THE',
    CREATE_AND_EDIT = 'ACTION_ADD_EDIT',
    CREATE_A_PUBLICATION = 'GLOBAL.CREATE_A_PUBLICATION',
    CREATE_ONLY = 'ACTION_CREATE',
    CREATE_WITH_ASSISTANT = 'GLOBAL.CREATE_WITH_ASSISTANT',
    CREATION_DATE = 'CREATION_DATE',
    CROP = 'CROP',
    CROPPER_DIALOG_TITLE = 'FRONT.CROPPER_DIALOG.TITLE',
    CSV_ANALYSIS_ERROR_INTRO = 'GLOBAL.CSV_ANALYSIS_ERROR_INTRO',
    CSV_UPLOAD_SUCCESSFULL = 'GLOBAL.CSV_UPLOAD_SUCCESSFULL',
    CURRENTLY_GENERATING = 'PLAY.GENERATING',
    CURRENT_SITE = 'GLOBAL.CURRENT_SITE',
    CUSTOM = 'GLOBAL.CUSTOM',
    CUSTOMER = 'GLOBAL.CUSTOMER',
    CUSTOMER_ID = 'GLOBAL.CUSTOMER_ID',
    CUSTOMIZE = 'GLOBAL.CUSTOMIZE',
    CUSTOM_MESSAGE = 'GLOBAL.CUSTOM_MESSAGE',
    DARK = 'GLOBAL.DARK',
    DASHBOARD = 'GLOBAL.DASHBOARD',
    DATA_SOURCES = 'GLOBAL.DATA_SOURCES',
    DATE = 'DATE',
    DATE_FORMAT = 'DATE_FORMAT',
    DATE_FORMAT_COMPLETE = 'DATE_FORMAT_COMPLETE',
    DATE_FORMAT_SHORT_COMPLETE = 'DATE_FORMAT_SHORT_COMPLETE',
    DATE_FROM = 'DATE_FROM',
    DATE_PICKER = 'GLOBAL.DATE_PICKER',
    DATE_RANGE = 'ADMIN.SEARCH_ANALYTICS_DATE_RANGE_LABEL',
    DATE_TO = 'DATE_TO',
    DAY = 'GLOBAL.DAY',
    DAYS = 'GLOBAL.DAYS',
    DEACTIVATE = 'GLOBAL.DEACTIVATE',
    DEACTIVATED = 'GLOBAL.DEACTIVATED',
    DECLINE = 'FRONT.GDPR_BANNER.DECLINE',
    DECLINED = 'CALENDAR.EVENT_STATUS_DECLINED_ARIA_LABEL',
    DEFAULT = 'DEFAULT',
    DEFAULT_COLOR = 'GLOBAL.DEFAULT_COLOR',
    DEFAULT_VALUE = 'GLOBAL.DEFAULT_VALUE',
    DELETABLE = 'CAN_PAGE_DELETE',
    DELETE = 'GLOBAL.DELETE',
    DELETED = 'GLOBAL.DELETED',
    DELETE_ALL = 'GLOBAL.DELETE_ALL',
    DELETE_CATEGORY = 'COMMUNITIES.DELETE_CATEGORY',
    DELETE_ENTITY = 'GLOBAL.DELETE_ENTITY',
    DELETE_FILE = 'GLOBAL.DELETE_FILE',
    DELETE_NB_TEMPLATES = 'GLOBAL.DELETE_NB_TEMPLATES',
    DELETE_SELECTED_ITEMS = 'ADMIN_DELETE_SELECTED_ITEMS',
    DELETE_SELECTED_ITEMS_DESCRIPTION = 'ADMIN_DELETE_SELECTED_ITEMS_DESCRIPTION',
    DELETE_SELECTED_ITEMS_ERROR = 'ADMIN_DELETE_SELECTED_ITEMS_ERROR',
    DELETE_SELECTED_ITEMS_SUCCESS = 'ADMIN_DELETE_SELECTED_ITEMS_SUCCESS',
    DELIVERED = 'GLOBAL.DELIVERED',
    DEPLOYED = 'GLOBAL.DEPLOYED',
    DEPLOYING = 'GLOBAL.DEPLOYING',
    DEPRECATED = 'FRONT.DEPRECATION_WARNING.SELECTION.MESSAGE',
    DEPRECATED_HELP_MESSAGE = 'GLOBAL.DEPRECATED_HELP_MESSAGE',
    DEPRECATED_OPTIONS = 'GLOBAL.DEPRECATED_OPTIONS',
    DESCENDING = 'FRONT.SETTINGS.DESCENDING_SORT_ORDER',
    DESCRIPTION = 'GLOBAL.DESCRIPTION',
    DESCRIPTION_WITH_LANG = 'GLOBAL.DESCRIPTION_WITH_LANG',
    DESIGNER = 'GLOBAL.DESIGNER',
    DETAILS = 'GLOBAL.DETAILS',
    DEVICES_DESKTOP = 'ANALYTICS.DEVICES_DESKTOP',
    DEVICES_LAPTOP = 'GLOBAL.DEVICES_LAPTOP',
    DEVICES_MOBILE = 'ANALYTICS.DEVICES_MOBILE',
    DEVICES_TABLET = 'ANALYTICS.DEVICES_TABLET',
    DIGITAL_ASSISTANT = 'ADMIN.ANALYTICS.DIGITAL_ASSISTANT_TAB',
    DIRECTORIES = 'SEARCH_PLUS_DIRECTORY_TAB',
    DIRECTORY = 'GLOBAL.DIRECTORY',
    DIRECTORY_ENTRIES = 'ADMIN.ANALYTICS.DIRECTORY_ENTRIES_TAB',
    DIRECTORY_ENTRY = 'ACTION_TYPE_DIRECTORY_ENTRY',
    DIRECTORY_ENTRY_FAVORITES = 'ACTION_TYPE_DIRECTORY_ENTRY_FAVORITES',
    DISABLE = 'GLOBAL.DISABLE',
    DISABLED = 'GLOBAL.DISABLED',
    DISCARD = 'GLOBAL.DISCARD',
    DISCARD_CHANGES = 'GLOBAL.DISCARD_CHANGES',
    DISCARD_CHANGES_CONFIRM = 'GLOBAL.DISCARD_CHANGES_CONFIRM',
    DISCARD_DRAFT = 'GLOBAL.DISCARD_DRAFT',
    DISCONNECT = 'GLOBAL.DISCONNECT',
    DISMISS = 'GLOBAL.DISMISS',
    DISPLAY = 'GLOBAL.DISPLAY',
    DISPLAY_CONTEXTUAL_ACTIONS_MENU = 'GLOBAL.DISPLAY_CONTEXTUAL_ACTIONS_MENU',
    DISPLAY_MORE_RESULTS = 'SEARCH_PLUS_SHOW_MORE',
    DISPLAY_ONLY_FOR_LANGUAGES = 'LANGUAGES.DISPLAY_ONLY_FOR_LANGUAGES',
    DISPLAY_SOMETHING = 'GLOBAL.DISPLAY_SOMETHING',
    DISPLAY_UNAVAILABLE_STATE_DESCRIPTION = 'GLOBAL.DISPLAY_UNAVAILABLE_STATE_DESCRIPTION',
    DISPLAY_UNAVAILABLE_STATE_TITLE = 'GLOBAL.DISPLAY_UNAVAILABLE_STATE_TITLE',
    DOCUMENTATION = 'GLOBAL.DOCUMENTATION',
    DOMAIN = 'CONNECTORS.DOMAIN',
    DONE = 'GLOBAL.DONE',
    DOWNLOAD = 'GLOBAL.DOWNLOAD',
    DOWNLOAD_EXAMPLE = 'GLOBAL.DOWNLOAD_EXAMPLE',
    DOWNLOAD_FILE = 'ADMIN.NANNY.DOWNLOAD_FILE',
    DOWNLOAD_LOG = 'GLOBAL.DOWNLOAD_LOG',
    DO_NOT_SHOW_THIS_MESSAGE_AGAIN = 'GLOBAL.DO_NOT_SHOW_THIS_MESSAGE_AGAIN',
    DRAFT = 'GLOBAL.DRAFT',
    DRAFTS = 'GLOBAL.DRAFTS',
    DRAFT_COUNT_PLURALIZED = 'GLOBAL.DRAFT_COUNT_PLURALIZED',
    DRAG = 'GLOBAL.DRAG',
    DRAG_CANCELED = 'LUMX.DRAGGABLE.DRAG_CANCELED',
    DRAG_ENDED = 'LUMX.DRAGGABLE.DRAG_ENDED',
    DRAG_STARTING = 'LUMX.DRAGGABLE.DRAG_STARTING',
    DRAG_UPDATES = 'LUMX.DRAGGABLE.DRAG_UPDATES',
    DRIVE = 'GLOBAL.DRIVE',
    DUPLICATE = 'GLOBAL.DUPLICATE',
    DURATION = 'GLOBAL.DURATION',
    DURATION_FORMAT_DHMS = 'GLOBAL.DURATION_FORMAT_DHMS',
    DURATION_FORMAT_HMS = 'GLOBAL.DURATION_FORMAT_HMS',
    DURATION_FORMAT_MS = 'GLOBAL.DURATION_FORMAT_MS',
    DURATION_FORMAT_S = 'GLOBAL.DURATION_FORMAT_S',
    DYNAMIC = 'GLOBAL.DYNAMIC',
    D_M_YYYY = 'D-M-YYYY',
    EDIT = 'GLOBAL.EDIT',
    EDITABLE = 'CAN_PAGE_EDIT',
    EDITABLE_BY = 'CONTENT_SETTINGS_EDITABLE_BY',
    EDITED_AT_DATE = 'GLOBAL.EDITED_AT_DATE',
    EDITORS = 'EDITOR_PLURAL',
    EDIT_ALT_TEXT = 'WREX_IMAGE.INSERT_ALT_TEXT_EDIT',
    EDIT_DETAILS = 'GLOBAL.EDIT_DETAILS',
    EDIT_MESSAGE = 'GLOBAL.EDIT_MESSAGE',
    EDIT_OPTIONS = 'GLOBAL.EDIT_OPTIONS',
    EDIT_PROFILE = 'GLOBAL.EDIT_PROFILE',
    EDIT_SOURCE = 'GLOBAL.EDIT_SOURCE',
    EMAIL = 'GLOBAL.EMAIL',
    EMBED = 'GLOBAL.EMBED',
    EMOJI_PICKER_ACTIVITY_CATEGORY = 'LUMX.EMOJI_PICKER_ACTIVITY_CATEGORY',
    EMOJI_PICKER_ANIMAL_CATEGORY = 'LUMX.EMOJI_PICKER_ANIMAL_CATEGORY',
    EMOJI_PICKER_FLAG_CATEGORY = 'LUMX.EMOJI_PICKER_FLAG_CATEGORY',
    EMOJI_PICKER_FOOD_CATEGORY = 'LUMX.EMOJI_PICKER_FOOD_CATEGORY',
    EMOJI_PICKER_OBJECT_CATEGORY = 'LUMX.EMOJI_PICKER_OBJECT_CATEGORY',
    EMOJI_PICKER_RECENT_CATEGORY = 'LUMX.EMOJI_PICKER_RECENT_CATEGORY',
    EMOJI_PICKER_SMILEY_CATEGORY = 'LUMX.EMOJI_PICKER_SMILEY_CATEGORY',
    EMOJI_PICKER_SYMBOL_CATEGORY = 'LUMX.EMOJI_PICKER_SYMBOL_CATEGORY',
    EMOJI_PICKER_TRAVEL_CATEGORY = 'LUMX.EMOJI_PICKER_TRAVEL_CATEGORY',
    EMPTY_VERB = 'GLOBAL.EMPTY_VERB',
    ENABLE = 'GLOBAL.ENABLE',
    ENABLED = 'GLOBAL.ENABLED',
    END_DATE = 'END_DATE',
    END_TIME = 'END_TIME',
    ENTER_A_URL = 'ADMIN.TERMS_AND_CONDITIONS.REDIRECT_URL.PLACEHOLDER',
    ENTER_URL = 'GLOBAL.ENTER_URL',
    ENTITY_MOVED = 'GLOBAL.ENTITY_MOVED',
    ENTITY_REMOVED_COUNT_MESSAGE = 'GLOBAL.A11Y_ENTITY_REMOVED_COUNT_MESSAGE',
    ERROR = 'GLOBAL.ERROR',
    ERRORS_IN_FILE = 'GLOBAL.ERRORS_IN_FILE',
    ERROR_CHANGES_NOT_SAVED = 'GLOBAL.ERROR_CHANGES_NOT_SAVED',
    ERROR_COLOR_CONTRAST_RATIO = 'GLOBAL.ERROR_COLOR_CONTRAST_RATIO',
    ERROR_FILE_FORMAT = 'GLOBAL.ERROR_FILE_FORMAT',
    ERROR_INVALID_JSON = 'GLOBAL.ERROR_INVALID_JSON',
    ERROR_MANDATORY_FIELD = 'GLOBAL.ERROR_MANDATORY_FIELD',
    ERROR_NOT_AUTHORIZED = 'ERROR_NOT_AUTHORIZED',
    ERROR_OCCURRED_TRY_AGAIN = 'GLOBAL.ERROR_OCCURRED_TRY_AGAIN',
    ERROR_PAGE_404_DESCRIPTION = '404_DESCRIPTION',
    ERROR_PAGE_404_TITLE = '404_TITLE',
    ERROR_PAGE_500_DESCRIPTION = '500_DESCRIPTION',
    ERROR_PAGE_500_TITLE = '500_TITLE',
    ERROR_PAGE_RESTRICTED_ACCESS_DESCRIPTION = 'GLOBAL.ERROR_PAGE_RESTRICTED_ACCESS_DESCRIPTION',
    ERROR_PAGE_RESTRICTED_ACCESS_TITLE = 'GLOBAL.ERROR_PAGE_RESTRICTED_ACCESS_TITLE',
    ERROR_PAGE_UNAVAILABLE_DESCRIPTION = 'GLOBAL.ERROR_PAGE_UNAVAILABLE_DESCRIPTION',
    ERROR_PAGE_UNAVAILABLE_TITLE = 'GLOBAL.ERROR_PAGE_UNAVAILABLE_TITLE',
    ERROR_URL_BAD_FORMAT = 'ERROR_URL_BAD_FORMAT',
    ERROR_WHILE_FETCHING_DATA = 'SA_ANALYTICS_FETCH_DATA_RETRY_DESC',
    EVENT = 'GLOBAL.EVENT',
    EVENTS = 'COMMUNITY_SETTINGS.EVENT_SERVICE_TITLE',
    EVERYONE = 'GLOBAL.EVERYONE',
    EXCERPT = 'GLOBAL.EXCERPT',
    EXECUTE = 'GLOBAL.EXECUTE',
    EXIT_FULLSCREEN = 'GLOBAL.EXIT_FULLSCREEN',
    EXPAND = 'GLOBAL.EXPAND',
    EXPANDED = 'GLOBAL.EXPANDED',
    EXPIRATION = 'GLOBAL.EXPIRATION',
    EXPIRATION_DATE = 'GLOBAL.EXPIRATION_DATE',
    EXPIRED = 'PLAY.VIDEO_STATUS_EXPIRED',
    EXPIRED_ON_DATE = 'CONTENT_ADMIN.EXPIRED_ON_DATE',
    EXPIRES_ON = 'GLOBAL.EXPIRES_ON',
    EXPORT = 'GLOBAL.EXPORT',
    EXPORT_CSV = 'GLOBAL.EXPORT_CSV',
    EXTENSIONS = 'GLOBAL.EXTENSIONS',
    EXTERNAL = 'SEARCH_SETTINGS.EXTERNAL_SOURCE_TITLE',
    EXTERNAL_LINK = 'GLOBAL.EXTERNAL_LINK',
    FAMILY_NAME = 'GLOBAL.FAMILY_NAME',
    FAVORITE_SITES = 'GLOBAL.FAVORITE_SITES',
    FEATURED = 'FRONT.SEARCH.RESULT_IS_FEATURED',
    FEATURED_IMAGE = 'WIDGET_TYPE_FEATURED-IMAGE_PLACEHOLDER',
    FEATURED_IMAGE_TOOLBAR = 'GLOBAL.FEATURED_IMAGE_TOOLBAR',
    FEATURES = 'GLOBAL.FEATURES',
    FEED = 'GLOBAL.FEED',
    FEEDS = 'GLOBAL.FEEDS',
    FIELD_IS_REQUIRED = 'GLOBAL.FIELD_IS_REQUIRED',
    FILE = 'GLOBAL.FILE',
    FILES_UPLOADED = 'GLOBAL.FILES_UPLOADED',
    FILE_ANALYZED = 'GLOBAL.FILE_ANALYZED',
    FILE_EXTENSION_NOT_SUPPORTED = 'GLOBAL.FILE_EXTENSION_NOT_SUPPORTED',
    FILE_REPLACED = 'GLOBAL.FILE_REPLACED',
    FILE_UPLOADED = 'GLOBAL.FILE_UPLOADED',
    FILTER = 'GLOBAL.FILTER',
    FILTERING = 'GLOBAL.FILTERING',
    FILTERS = 'GLOBAL.FILTERS',
    FILTER_BY = 'GLOBAL.FILTER_BY',
    FINISH = 'GLOBAL.FINISH',
    FINISHED = 'GLOBAL.FINISHED',
    FIRST_NAME = 'GLOBAL.FIRST_NAME',
    FLOW = 'GLOBAL.FLOW',
    FOLDER = 'GLOBAL.FOLDER',
    FOLLOW = 'GLOBAL.FOLLOW',
    FOLLOWED = 'GLOBAL.FOLLOWED',
    FOOTER = 'FOOTER',
    FORMAT_COLON = 'GLOBAL.FORMAT_COLON',
    FORMS = 'BOOKMARKED_MS_APPS_FORMS',
    FROM = 'GLOBAL.FROM',
    FROM_COMPUTER = 'GLOBAL.FROM_COMPUTER',
    FROM_DEVICE = 'GLOBAL.FROM_DEVICE',
    FROM_TO = 'GLOBAL.FROM_TO',
    FULLSCREEN = 'GLOBAL.FULLSCREEN',
    FULLSCREEN_IMAGE = 'GLOBAL.FULLSCREEN_IMAGE',
    FULLSCREEN_IMAGE_SLIDESHOW = 'GLOBAL.FULLSCREEN_IMAGE_SLIDESHOW',
    FULL_NAME = 'FRONT.USER_DIRECTORY.FULL_NAME',
    GENERAL = 'GLOBAL.GENERAL',
    GENERAL_SETTINGS = 'ADMIN.NAV.MOBILE_GENERAL_SETTINGS',
    GENERATE = 'GLOBAL.GENERATE',
    GENERIC_ERROR = 'GLOBAL.ERROR.GENERIC',
    GET = 'GLOBAL.GET',
    GIVEN_NAME = 'GLOBAL.GIVEN_NAME',
    GLOBAL_INSTRUCTIONS = 'GLOBAL.GLOBAL_INSTRUCTIONS',
    GLOBAL_SETTINGS = 'ADMIN.ADVANCED_SETTINGS.DEFAULT_CATEGORY',
    GLOBAL_WIDGET = 'ACTION_TYPE_GLOBAL_WIDGET',
    GOOGLE = 'ADMIN_RESELLER_CONSOLE_TAB_GOOGLE',
    GOOGLE_ANALYTICS = 'GLOBAL.GOOGLE_ANALYTICS',
    GOOGLE_TEAM_DRIVE = 'GLOBAL.GOOGLE_TEAM_DRIVE',
    GO_BACK = 'GLOBAL.GO_BACK',
    GO_TO_HOMEPAGE = 'FRONT.GO_HOMEPAGE',
    GRANT_TYPE = 'CONNECTORS.GRANT_TYPE',
    GROUP = 'GLOBAL.GROUP',
    GROUPS_COUNT = 'GLOBAL.GROUPS_COUNT',
    GROUP_NAME = 'GLOBAL.GROUP_NAME',
    HELLO_USERNAME = 'GLOBAL.HELLO_USERNAME',
    HELPFUL = 'GLOBAL.HELPFUL',
    HEXADECIMAL_COLOR_ERROR = 'GLOBAL.HEXADECIMAL_COLOR_ERROR',
    HIDDEN = 'GLOBAL.HIDDEN',
    HIDE = 'HIDE',
    HIDE_ADVANCED_SETTINGS = 'GLOBAL.HIDE_ADVANCED_SETTINGS',
    HIDE_CONTEXTUAL_ACTIONS_MENU = 'GLOBAL.HIDE_CONTEXTUAL_ACTIONS_MENU',
    HIDE_FILTERS = 'FRONT.SEARCH.HIDE_FILTERS',
    HIDE_MESSAGE = 'GLOBAL.HIDE_MESSAGE',
    HIGHLIGHTED_FOR = 'LOOKER_CONTENT_HIGHLIGHTED_FOR',
    HISTORY = 'SOCIAL_PROFILE_HISTORY',
    HOME = 'ADMIN.MOBILE.HOME.FEATURE_NAME',
    HOMEPAGE = 'FRONT.COMMUNITY.DASHBOARD',
    HOME_PAGE = 'GLOBAL.HOME_PAGE',
    HOUR = 'GLOBAL.HOUR',
    HOW_IT_WORKS = 'GLOBAL.HOW_IT_WORKS',
    ICON = 'GLOBAL.ICON',
    ID = 'GLOBAL.ID',
    IDENTIFIER = 'ADMIN.COMMUNITY.SETUP.FIELD.CHAT.CHANNEL.ID',
    IGNORE = 'WREX_AI.IGNORE_SUGGESTION',
    IMAGE = 'GLOBAL.IMAGE',
    IMAGES_UPLOADED = 'GLOBAL.IMAGES_UPLOADED',
    IMAGE_UPLOADED = 'GLOBAL.IMAGE_UPLOADED',
    IMMEDIATELY = 'GLOBAL.IMMEDIATELY',
    IMPORT = 'GLOBAL.IMPORT',
    IN = 'GLOBAL.IN',
    INACTIVE = 'SA_SOCIAL_NETWORK_NOT_ACTIVE',
    INCOMPLETE_TRANSLATION = 'GLOBAL.INCOMPLETE_TRANSLATION',
    INCOMPLETE_TRANSLATIONS_DETAIL_1 = 'GLOBAL.INCOMPLETE_TRANSLATIONS_DETAIL_1',
    INCOMPLETE_TRANSLATIONS_DETAIL_2 = 'GLOBAL.INCOMPLETE_TRANSLATIONS_DETAIL_2',
    INCOMPLETE_TRANSLATIONS_LIST = 'GLOBAL.INCOMPLETE_TRANSLATIONS_LIST',
    INCORRECT_TIME_START_AFTER_END = 'GLOBAL.INCORRECT_TIME_START_AFTER_END',
    INCORRECT_TIME_START_EQUAL_END = 'EVENTS.INCORRECT_TIME_START_EQUAL_END',
    INFORMATION = 'GLOBAL.INFORMATION',
    INSERT = 'GLOBAL.INSERT',
    INSERT_VIDEO = 'FRONT.ATTACHMENTS.ADD_VIDEO',
    INSIGHTS = 'ADMIN.FOLKSONOMY.INSIGHTS',
    INTEGRATION = 'GLOBAL.INTEGRATION',
    INTEGRATIONS = 'NATIVE_INTEGRATIONS',
    INTERNAL = 'GLOBAL.INTERNAL',
    INVALID_EMAIL = 'SERVER_ERROR_INVALID_EMAIL',
    INVALID_FIELD = 'GLOBAL.INVALID_FIELD',
    INVALID_KEY = 'CONNECTORS.INVALID_KEY',
    IN_PROGRESS = 'GLOBAL.IN_PROGRESS',
    IN_VALUE = 'GLOBAL.IN_VALUE',
    IS = 'GLOBAL.IS',
    IS_ALREADY_ADDED = 'FRONT.TAGZ.ALREADY_ADDED',
    IS_EMPTY = 'GLOBAL.IS_EMPTY',
    JOURNEYS = 'JOURNEY_ADMIN.JOURNEYS',
    JUMP_TO = 'GLOBAL.JUMP_TO',
    KEEP = 'GLOBAL.KEEP',
    KEEP_AS_IS = 'GLOBAL.KEEP_AS_IS',
    KEEP_EDITING = 'GLOBAL.KEEP_EDITING',
    KEY = 'GLOBAL.KEY',
    KEYWORD = 'WIDGET_TYPE_CONTENT-FILTER_QUERY',
    KNOWLEDGE = 'MARKETPLACE.EXTENSIONS_TOPIC_KNOWLEDGE',
    KNOW_MORE = 'KNOW_MORE',
    LABEL = 'GLOBAL.LABEL',
    /**
     * Label (English)
     */
    LABEL_LOCALIZED = 'GLOBAL.LABEL_LOCALIZED',
    LANGUAGE = 'FRONT.PROCESS_MAKER.LANGUAGE',
    LANGUAGES = 'ADMIN_INSTANCE_LANGS',
    LANGUAGES_NUMBER = 'GLOBAL.LANGUAGES_NUMBER',
    LANGUAGE_SWITCHER_ARIA_LABEL = 'FRONT.LANGUAGE_SWITCHER.ARIA_LABEL',
    LAST_CALCULATED_ON = 'GLOBAL.LAST_CALCULATED_ON',
    LAST_DEPLOYMENT = 'GLOBAL.LAST_DEPLOYMENT',
    LAST_MODIFIED_ON = 'GLOBAL.LAST_MODIFIED_ON',
    LAST_NAME = 'ADMIN_FILTER_LAST_NAME',
    LAST_UPDATE = 'GLOBAL.LAST_UPDATE',
    LAST_UPDATED_DATE = 'WIDGET_TYPE_CONTENT-LIST_UPDATED-DATE',
    LAST_UPDATED_ON = 'LAST_UPDATED_ON',
    LAST_UPDATED_ON_DATE = 'GLOBAL.LAST_UPDATED_ON_DATE',
    LAST_USED = 'GLOBAL.LAST_USED',
    LATEST = 'GLOBAL.LATEST',
    LATEST_TO_OLDEST = 'GLOBAL.LATEST_TO_OLDEST',
    LEARNERS = 'GLOBAL.LEARNERS',
    LEARNING = 'GLOBAL.LEARNING',
    LEARN_MORE = 'GLOBAL.LEARN_MORE',
    LEAST_RECENT_ACTIVITY = 'GLOBAL.LEAST_RECENT_ACTIVITY',
    LEAVE = 'GLOBAL.LEAVE',
    LEAVE_WITHOUT_SAVING = 'GLOBAL.LEAVE_WITHOUT_SAVING',
    LESS = 'GLOBAL.LESS',
    LESS_FILTERS = 'GLOBAL.LESS_FILTERS',
    LESS_SETTINGS = 'GLOBAL.LESS_SETTINGS',
    LIBRARY = 'GLOBAL.LIBRARY',
    LIGHT = 'STYLE.FONT.LIGHT',
    LIKE = 'LIKE_BUTTON_LABEL',
    LIKES = 'LIKE_BUTTON_LABEL_PLURAL',
    LIKE_PLURALIZE = 'GLOBAL.LIKE_PLURALIZE',
    LIMITED = 'GLOBAL.LIMITED',
    LINE_ERROR = 'GLOBAL.LINE_ERROR',
    LINK = 'GLOBAL.LINK',
    LINK_COPIED = 'FRONT.MEDIA_PICKER.LINK_COPIED',
    LINK_PREVIEW = 'GLOBAL.LINK_PREVIEW',
    LINK_TO_COPY = 'GLOBAL.LINK_TO_COPY',
    LIVE = 'GLOBAL.LIVE',
    LOADING = 'GLOBAL.LOADING',
    LOCATION = 'FRONT.EVENT.DIALOG.LOCATION_LABEL',
    LOGGED_IN = 'GLOBAL.LOGGED_IN',
    LOG_IN = 'GLOBAL.LOG_IN',
    LUMAPPS = 'GLOBAL.LUMAPPS',
    LUMWORK = 'SEARCH_PLUS_LUMWORK_TAB',
    MAIN_DETAILS = 'GLOBAL.MAIN_DETAILS',
    MANAGE = 'GLOBAL.MANAGE',
    MANAGER = 'GLOBAL.MANAGER',
    MANAGERS = 'SPACES.MANAGERS',
    MANAGE_TRANSLATIONS = 'LANGUAGES.MANAGE_TRANSLATIONS',
    MANDATORY = 'GLOBAL.MANDATORY',
    MANUAL = 'GLOBAL.MANUAL',
    MARK_AS_ATTENDED = 'GLOBAL.MARK_AS_ATTENDED',
    MAXIMUM_SIZE_EXCEEDED = 'MICROAPP.MAXIMUM_SIZE_EXCEEDED',
    MAX_FILE_SIZE = 'MICRO_APP_INTEGRATIONS.MAX_FILE_SIZE',
    MAX_RESULTS_NUMBER_HELP = 'GLOBAL.MAX_RESULTS_NUMBER_HELP',
    MEDIA = 'GLOBAL.MEDIA',
    MEDIA_LIBRARY = 'GLOBAL.MEDIA_LIBRARY',
    MEMBER = 'GLOBAL.MEMBER',
    MESSAGE = 'GLOBAL.MESSAGE',
    MESSAGE_TO_REQUESTER = 'GLOBAL.MESSAGE_TO_REQUESTER',
    METADATA = 'WIDGET_TYPE_CONTENT-LIST_METADATA',
    MICROSOFT = 'GLOBAL.MICROSOFT',
    MICRO_APP = 'MARKETPLACE.EXTENSION_TYPE_MICRO_APP',
    MICRO_APPS = 'LOOKER_PLATFORM_MICROAPPS_DASHBOARD_MAIN_TITLE',
    MINUTES = 'GLOBAL.MINUTES',
    MISSION = 'GLOBAL.MISSION',
    MOBILE = 'GLOBAL.MOBILE',
    MOBILE_COURSE = 'GLOBAL.MOBILE_COURSE',
    MOBILE_NAVIGATION = 'GLOBAL.MOBILE_NAVIGATION',
    MOBILE_PUSH = 'GLOBAL.MOBILE_PUSH',
    MODIFICATIONS_SAVED = 'GLOBAL.MODIFICATIONS_SAVED',
    MODIFY = 'GLOBAL.MODIFY',
    MONTH = 'GLOBAL.MONTH',
    MONTHS = 'GLOBAL.MONTHS',
    MORE = 'GLOBAL.MORE',
    MORE_ACTIONS = 'GLOBAL.MORE_ACTIONS',
    MORE_FILTERS = 'GLOBAL.MORE_FILTERS',
    MORE_INFORMATION = 'FRONT.USER.PROFILE.MORE_INFO.LINK',
    MORE_OPTIONS = 'GLOBAL.MORE_OPTIONS',
    MORE_RESULTS = 'GLOBAL.MORE_RESULTS',
    MORE_SETTINGS = 'GLOBAL.MORE_SETTINGS',
    MOSAIC = 'GLOBAL.MOSAIC',
    MOST_RECENT = 'GLOBAL.MOST_RECENT',
    MOST_RECENT_ACTIVITY = 'GLOBAL.MOST_RECENT_ACTIVITY',
    MOST_RELEVANT = 'GLOBAL.MOST_RELEVANT',
    MOVE = 'GLOBAL.MOVE',
    MOVED = 'GLOBAL.MOVED',
    MOVE_DOWN = 'GLOBAL.MOVE_DOWN',
    MOVE_HERE = 'GLOBAL.MOVE_HERE',
    MOVE_SOMETHING = 'GLOBAL.MOVE_SOMETHING',
    MOVE_TO = 'FRONT.MEDIA_PICKER.MOVE_TO',
    MOVE_TO_BOTTOM = 'GLOBAL.MOVE_TO_BOTTOM',
    MOVE_TO_TOP = 'GLOBAL.MOVE_TO_TOP',
    MOVE_UP = 'GLOBAL.MOVE_UP',
    NAME = 'GLOBAL.NAME',
    NATIVE_SEARCH = 'GLOBAL.NATIVE_SEARCH',
    NAVIGATE = 'GLOBAL.NAVIGATE',
    NAVIGATED_TO_PAGE = 'GLOBAL.NAVIGATED_TO_PAGE',
    NAVIGATION = 'ADMIN.MOBILE.NAVIGATION.TITLE',
    NB_OPTIONS_AVAILABLE = 'GLOBAL.NB_OPTIONS_AVAILABLE',
    NB_PEOPLE = 'GLOBAL.NB_PEOPLE',
    NB_RESULTS = 'GLOBAL.NB_RESULTS',
    NB_RESULTS_DISPLAYED = 'GLOBAL.NB_RESULTS_DISPLAYED',
    NB_RESULTS_DISPLAYED_FOR_QUERY = 'GLOBAL.NB_RESULTS_DISPLAYED_FOR_QUERY',
    NB_RESULTS_DISPLAYED_OUT_OF_TOTAL = 'GLOBAL.NB_RESULTS_DISPLAYED_OUT_OF_TOTAL',
    NB_RESULTS_DISPLAYED_OUT_OF_TOTAL_FOR_QUERY = 'GLOBAL.NB_RESULTS_DISPLAYED_OUT_OF_TOTAL_FOR_QUERY',
    NB_VIDEOS = 'GLOBAL.NB_VIDEOS',
    NEW = 'NEW',
    NEWSLETTER = 'ACTION_TYPE_NEWSLETTER',
    NEWSLETTERS = 'ADMIN.NAV.NEWSLETTER',
    NEW_CATEGORY = 'GLOBAL.NEW_CATEGORY',
    NEW_ITEMS_LOADED_MESSAGE = 'GLOBAL.A11Y_NEW_ITEMS_LOADED_MESSAGE',
    NEW_LANGUAGE = 'GLOBAL.NEW_LANGUAGE',
    NEW_MESSAGE = 'GLOBAL.NEW_MESSAGE',
    NEXT = 'GLOBAL.NEXT',
    NEXT_MONTH = 'GLOBAL.NEXT_MONTH',
    NEXT_SLIDE = 'LUMX.NEXT_SLIDE',
    NO = 'GLOBAL.NO',
    NOTE = 'GLOBAL.NOTE',
    NOTIFICATION = 'NOTIFICATION',
    NOTIFICATIONS = 'NOTIFICATIONS',
    NOTIFY = 'GLOBAL.NOTIFY',
    NOTIF_MAX_VALUES_REACHED = 'GLOBAL.NOTIF_MAX_VALUES_REACHED',
    NOT_ALLOWED = 'GLOBAL.NOT_ALLOWED',
    NOT_AUTHORIZED = 'ADMIN.NOT_AUTHORIZED',
    NOT_CREATED = 'GLOBAL.NOT_CREATED',
    NOT_DELIVERED = 'GLOBAL.NOT_DELIVERED',
    NOT_ENOUGH_DATA = 'GLOBAL.NOT_ENOUGH_DATA',
    NOT_HELPFUL = 'GLOBAL.NOT_HELPFUL',
    NOT_MANDATORY = 'GLOBAL.NOT_MANDATORY',
    NOT_PLANNED = 'GLOBAL.NOT_PLANNED',
    NOT_READY = 'GLOBAL.NOT_READY',
    NOT_SAVED = 'GLOBAL.NOT_SAVED',
    NOT_SENT = 'GLOBAL.NOT_SENT',
    NOT_STARTED = 'GLOBAL.NOT_STARTED',
    NOT_USED = 'GLOBAL.NOT_USED',
    NOT_VISIBLE_TO_READER = 'GLOBAL.NOT_VISIBLE_TO_READER',
    NO_DESCRIPTION = 'GLOBAL.NO_DESCRIPTION',
    NO_FILTERED_RESULTS = 'GLOBAL.NO_FILTERED_RESULTS',
    NO_MORE_THAN_X_LINES = 'GLOBAL.NO_MORE_THAN_X_LINES',
    NO_RESULTS = 'GLOBAL.NO_RESULTS',
    NO_RESULTS_FOR = 'GLOBAL.NO_RESULTS_FOR',
    NO_RESULTS_FOUND = 'GLOBAL.NO_RESULTS_FOUND',
    NO_RESULT_FOR_THIS_FILTER = 'GLOBAL.NO_RESULT_FOR_THIS_FILTER',
    NUMBER = 'GLOBAL.NUMBER',
    OAUTH_SCOPES_HELPER = 'CONNECTORS.SCOPES_HELPER',
    OAUTH_SCOPES_PLACEHOLDER = 'CONNECTORS.ADD_AN_ACTION',
    OCCURRENCES_DAY = 'JOURNEYS_CORE.DAY',
    OK = 'GLOBAL.OK',
    OKTA = 'GLOBAL.OKTA',
    OLDEST = 'GLOBAL.OLDEST',
    OLDEST_TO_LATEST = 'GLOBAL.OLDEST_TO_LATEST',
    ONE_DRIVE = 'GLOBAL.ONE_DRIVE',
    ONE_GROUP_LIMIT = 'GLOBAL.ONE_GROUP_LIMIT',
    ONGOING = 'GLOBAL.ONGOING',
    ONLY_NUMBERS = 'GLOBAL.ONLY_NUMBERS',
    ON_DATE = 'GLOBAL.ON_DATE',
    ON_DATE_TITLE = 'GLOBAL.ON_DATE_TITLE',
    OPEN = 'GLOBAL.OPEN',
    OPENED = 'GLOBAL.OPENED',
    OPEN_APP = 'GLOBAL.OPEN_APP',
    OPEN_IMAGE_IN_FULLSCREEN = 'GLOBAL.OPEN_IMAGE_IN_FULLSCREEN',
    OPEN_NEW_TAB = 'GLOBAL.OPEN_NEW_TAB',
    OPEN_SOMETHING = 'GLOBAL.OPEN_SOMETHING',
    OPERATOR = 'GLOBAL.OPERATOR',
    OPTIONAL = 'GLOBAL.OPTIONAL',
    OPTIONS = 'GLOBAL.OPTIONS',
    OR = 'GLOBAL.OR',
    ORDER = 'FRONT.SETTINGS.ORDERING',
    ORDER_BY = 'GLOBAL.ORDER_BY',
    ORDER_BY_UPLOADED_DATE_ASC = 'GLOBAL.ORDER_BY_UPLOADED_DATE_ASC',
    ORDER_BY_UPLOADED_DATE_DESC = 'GLOBAL.ORDER_BY_UPLOADED_DATE_DESC',
    ORGANIZATION = 'GLOBAL.ORGANIZATION',
    OTHER = 'GLOBAL.OTHER',
    OTHER_POSSIBLE_TRANSLATIONS_LANGS = 'GLOBAL.OTHER_POSSIBLE_TRANSLATIONS_LANGS',
    OTHER_SITES = 'GLOBAL.OTHER_SITES',
    OUTDATED = 'REPORTS.POST_REPORT_DIALOG_OUTDATED_REASON',
    OVERDUE = 'GLOBAL.OVERDUE',
    /**
     * @todo change to GLOBAL.OVERVIEW
     */
    OVERVIEW = 'ADMIN.ANALYTICS.DASHBOARD_TAB',
    OWNERSHIP = 'GLOBAL.OWNERSHIP',
    PAGE_IS_PRIVATE = 'GLOBAL.PAGE_IS_PRIVATE',
    PAGINATION_ON = 'GLOBAL.PAGINATION_ON',
    PARAMETERS = 'GLOBAL.PARAMETERS',
    PARTIAL_EDIT = 'ROLES.MENU_PARTIAL_EDIT_ACTION',
    PASSWORD = 'ADMIN_USER_DIRECTORY_PASSWORD',
    PASTE_URL = 'GLOBAL.PASTE_URL',
    PAUSE = 'GLOBAL.PAUSE',
    PAUSED = 'GLOBAL.PAUSED',
    PAUSE_VERB = 'GLOBAL.PAUSE_VERB',
    PENDING = 'GLOBAL.PENDING',
    PEOPLE = 'GLOBAL.PEOPLE',
    PEOPLE_SINGULAR_PLURAL = 'GLOBAL.PEOPLE_SINGULAR_PLURAL',
    PER = 'GLOBAL.PER',
    PERMISSIONS = 'GLOBAL.PERMISSIONS',
    PICK_DATE = 'GLOBAL.PICK_DATE',
    PICK_GROUPS = 'GLOBAL.PICK_GROUPS',
    PICK_ICON = 'GLOBAL.PICK_ICON',
    PLACE_ACTIVITY = 'GLOBAL.PLACE_ACTIVITY',
    PLANNED = 'GLOBAL.PLANNED',
    PLATFORM = 'GLOBAL.PLATFORM',
    PLAY = 'GLOBAL.PLAY',
    PLAYLISTS = 'PLAY.PLAYLISTS',
    PLEASE_WAIT = 'GLOBAL.PLEASE_WAIT',
    POST = 'GLOBAL.POST',
    POSTS = 'FRONT.COMMUNITY.POSTS',
    PRESS_ENTER_TO_ADD = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_MEMBERSHIPS.PRESS_ENTER_TO_ADD',
    PREVIEW = 'GLOBAL.PREVIEW',
    PREVIOUS = 'GLOBAL.PREVIOUS',
    PREVIOUS_MONTH = 'GLOBAL.PREVIOUS_MONTH',
    PREVIOUS_SLIDE = 'LUMX.PREVIOUS_SLIDE',
    PRIMARY_COLOR = 'MOBILE.CONFIGURATION_COLOR_THEME_LABEL',
    PRIORITY = 'GLOBAL.PRIORITY',
    PRIVATE = 'GLOBAL.PRIVATE',
    PROCESSING = 'GLOBAL.PROCESSING',
    PROFILE = 'GLOBAL.PROFILE',
    /**
     * Reference: LUMAPPS_APPLICATIONS.PROFILE_FIELDS_PLACEHOLDER
     */
    PROFILE_FIELDS_PLACEHOLDER = 'LUMAPPS_APPLICATIONS.PROFILE_FIELDS_PLACEHOLDER',
    PROGRESS_TRACKER_LABEL = 'GLOBAL.PROGRESS_TRACKER_LABEL',
    PROMOTED_SEARCH = 'GLOBAL.PROMOTED_SEARCH',
    PROPERTIES = 'FRONT.SETTINGS.PROPERTIES',
    PROVIDER = 'CONNECTORS.PROVIDER',
    PROVIDERS = 'ADMIN.NAV.PROVIDER',
    PROVISIONING = 'GLOBAL.PROVISIONING',
    PUBLIC = 'GLOBAL.PUBLIC',
    PUBLICATION = 'PLAY.PUBLICATION',
    PUBLICATION_DATE = 'GLOBAL.PUBLICATION_DATE',
    PUBLICATION_TYPES = 'GLOBAL.PUBLICATION_TYPES',
    PUBLIC_LINK = 'GLOBAL.PUBLIC_LINK',
    PUBLISH = 'GLOBAL.PUBLISH',
    PUBLISHABLE = 'CAN_PAGE_PUBLISH',
    PUBLISHED = 'CONTENT_STATUS_LIVE',
    PUBLISHED_IN_LOCATION = 'GLOBAL.PUBLISHED_IN_LOCATION',
    PUBLISHED_ON = 'PUBLISHED_ON',
    PUBLISHED_ON_DATE = 'GLOBAL.PUBLISHED_ON_DATE',
    PUBLISHED_ON_DATE_COLON = 'CONTENT_ADMIN.PUBLISHED_ON_DATE',
    PUBLISHED_SUCCESS = 'GLOBAL.PUBLISHED_SUCCESS',
    PUBLISH_NOW = 'DESIGNER.PUBLISH_NOW_LABEL',
    QUIZ = 'GLOBAL.QUIZ',
    QUIZ_GAME = 'GLOBAL.QUIZ_GAME',
    RANKING = 'GLOBAL.RANKING',
    REACTIONS = 'GLOBAL.REACTIONS',
    READ = 'ACTION_READ',
    RECEIVED_ON = 'GLOBAL.RECEIVED_ON',
    RECENT_CHANGES_NOT_SAVED = 'GLOBAL.RECENT_CHANGES_NOT_SAVED',
    RECOMMENDED = 'GLOBAL.RECOMMENDED',
    REDIRECT_URL = 'ADMIN.TERMS_AND_CONDITIONS.REDIRECT_URL.LABEL',
    REFERENCE_LANGUAGE = 'LANGUAGES.REFERENCE_LANGUAGE',
    REFER_TO_DOCUMENTATION_LINK = 'GLOBAL.REFER_TO_DOCUMENTATION_LINK',
    REFRESH = 'GLOBAL.REFRESH',
    REFUSE = 'GLOBAL.REFUSE',
    REFUSED = 'CONTENT_STATUS_REFUSED',
    REGISTRATION_STATUS = 'GLOBAL.REGISTRATION_STATUS',
    RELATIVE_CREATED_AT = 'GLOBAL.RELATIVE_CREATED_AT',
    RELATIVE_LAST_MODIFIED_DATE = 'GLOBAL.RELATIVE_LAST_MODIFIED_DATE',
    RELATIVE_PUBLISHED_DATE = 'GLOBAL.RELATIVE_PUBLISHED_DATE',
    RELATIVE_RECEIVED_DATE = 'GLOBAL.RELATIVE_RECEIVED_DATE',
    RELAUNCH_UPDATES = 'GLOBAL.RELAUNCH_UPDATES',
    RELEVANCE = 'GLOBAL.RELEVANCE',
    RELOAD = 'GLOBAL.RELOAD',
    RELOAD_PAGE = 'GLOBAL.RELOAD_PAGE',
    REMOVE = 'GLOBAL.REMOVE',
    REMOVED = 'GLOBAL.REMOVED',
    REMOVE_ALL = 'GLOBAL.REMOVE_ALL',
    REMOVE_ENTITY = 'GLOBAL.REMOVE_ENTITY',
    RENAME = 'GLOBAL.RENAME',
    REPLACE = 'GLOBAL.REPLACE',
    REPLACE_BY = 'GLOBAL.REPLACE_BY',
    REPLY = 'GLOBAL.REPLY',
    REQUESTS = 'NOTIFICATION_PRIORITY_NAME_5',
    REQUESTS_COUNT = 'GLOBAL.REQUESTS_COUNT',
    RESEND = 'GLOBAL.RESEND',
    RESET = 'RESET',
    RESET_FILTERS = 'GLOBAL.RESET_FILTERS',
    RESOLVE = 'GLOBAL.RESOLVE',
    RESOURCE_CENTER = 'GLOBAL.RESOURCE_CENTER',
    RESTORE = 'GLOBAL.RESTORE',
    RESTORED = 'GLOBAL.RESTORED',
    RESTRICTED_ACCESS = 'GLOBAL.RESTRICTED_ACCESS',
    RESTRICTED_TO = 'GLOBAL.RESTRICTED_TO',
    RESTRICTIONS = 'WIDGET_SETTINGS_RESTRICTIONS',
    RESTRICT_ACCESS = 'GLOBAL.RESTRICT_ACCESS',
    RESULT_GENERATED_BY_AI = 'GLOBAL.RESULT_GENERATED_BY_AI',
    RESULT_IS_RECOMMENDED = 'FRONT.SEARCH.RESULT_IS_RECOMMENDED',
    REVERT_TO_DRAFT = 'GLOBAL.REVERT_TO_DRAFT',
    RIGHT_NOW = 'RIGHT_NOW',
    ROLE = 'PLAY.ROLE',
    ROLES = 'PLAY.ROLES',
    ROLES_SETTINGS = 'GLOBAL.ROLES_SETTINGS',
    ROLE_ADMINISTRATOR = 'PLAY.ROLE_ADMINISTRATOR',
    RULE = 'GLOBAL.RULE',
    SAVE = 'GLOBAL.SAVE',
    SAVED = 'GLOBAL.SAVED',
    SAVED_AS_DRAFT_ON = 'GLOBAL.SAVED_AS_DRAFT_ON',
    SAVED_ON = 'GLOBAL.SAVED_ON',
    SAVE_AND_INSERT = 'GLOBAL.SAVE_AND_INSERT',
    SAVE_AS_DRAFT = 'SAVE_AS_DRAFT',
    SAVE_CHANGES = 'GLOBAL.SAVE_CHANGES',
    SAVING = 'GLOBAL.SAVING',
    SCHEDULE = 'GLOBAL.SCHEDULE',
    SCHEDULED = 'GLOBAL.SCHEDULED',
    SCHEDULED_COUNT_PLURALIZED = 'GLOBAL.SCHEDULED_COUNT_PLURALIZED',
    SCHEDULED_ERROR_COUNT_PLURALIZED = 'GLOBAL.SCHEDULED_ERROR_COUNT_PLURALIZED',
    SCHEDULED_ON = 'BROADCASTS.SCHEDULED_ON',
    SCHEDULED_ON_DATE = 'CONTENT_ADMIN.SCHEDULED_ON_DATE',
    SCOPES = 'CONNECTORS.SCOPES',
    SCORE = 'GLOBAL.SCORE',
    SEARCH = 'FRONT.SEARCH',
    SEARCH_BY_NAME = 'GLOBAL.SEARCH_BY_NAME',
    SEARCH_BY_TITLE = 'GLOBAL.SEARCH_BY_TITLE',
    SEARCH_BY_TITLE_OR_AUTHOR = 'GLOBAL.SEARCH_BY_TITLE_OR_AUTHOR',
    SEARCH_FIELD = 'GLOBAL.SEARCH_FIELD',
    SEARCH_FOR_SOMEONE = 'GLOBAL.SEARCH_FOR_SOMEONE',
    SEARCH_RESULTS = 'GLOBAL.SEARCH_RESULTS',
    SECONDARY_COLOR = 'GLOBAL.SECONDARY_COLOR',
    SEE_MORE_NB_ITEMS = 'FRONT.SEARCH.SEE_MORE_NB_ITEMS',
    SEE_TRANSLATION = 'TRANSLATE_CONTENT',
    SEGMENT = 'LOOKER_GLOBAL_SEGMENT',
    SELECT = 'GLOBAL.SELECT',
    SELECTED_ITEMS_COUNT = 'GLOBAL.SELECTED_ITEMS_COUNT',
    SELECTION = 'GLOBAL.SELECTION',
    SELECT_ALL = 'GLOBAL.SELECT_ALL',
    SELECT_ALL_DESELECT_ALL = 'NOTIFICATION.PREFERENCES.TABLE.CHECK_ALL.ROW.LABEL',
    SELECT_AN_ICON_TO_MAKE_THIS_OPTION_AVAILABLE = 'GLOBAL.SELECT_AN_ICON_TO_MAKE_THIS_OPTION_AVAILABLE',
    SELECT_AN_OPTION = 'FRONT.EVENT.DIALOG.LINK_LABEL_PLACEHOLDER',
    SELECT_AUTHOR = 'GLOBAL.SELECT_AUTHOR',
    SELECT_DESELECT = 'GLOBAL.SELECT_DESELECT',
    SELECT_FIELDS = 'GLOBAL.SELECT_FIELDS',
    SELECT_FOLDER = 'GLOBAL.SELECT_FOLDER',
    SELECT_GROUPS = 'GLOBAL.SELECT_GROUPS',
    SELECT_IMAGE = 'SELECT_IMAGE',
    SELECT_LANGUAGES = 'GLOBAL.SELECT_LANGUAGES',
    SELECT_PROVIDER = 'GLOBAL.SELECT_PROVIDER',
    SELECT_PROVIDER_TYPE = 'CONNECTORS.SELECT_PROVIDER_TYPE',
    SELECT_REASON_LISTED = 'GLOBAL.SELECT_REASON_LISTED',
    SELECT_SITES = 'INSTANCE_PICKER_SUBHEADER_LIBRARY',
    SELECT_SPACES = 'GLOBAL.SELECT_SPACES',
    SELECT_USER = 'GLOBAL.SELECT_USER',
    SELECT_USERPROFILE_FIELD = 'JOURNEY_ADMIN.STAKEHOLDER_USERPROFILE_FIELD_LABEL',
    SELECT_USERS = 'GLOBAL.SELECT_USERS',
    SELF_REGISTRATION_TITLE = 'MOBILE_LOGIN.SELF_REGISTRATION_TITLE',
    SEND = 'GLOBAL.SEND',
    SEND_TEST = 'GLOBAL.SEND_TEST',
    SEND_TO = 'GLOBAL.SEND_TO',
    SENT = 'GLOBAL.SENT',
    SENT_DATE = 'ADMIN.NEWSLETTER.SENT_DATE',
    SENT_ON = 'GLOBAL.SENT_ON',
    SENT_TO = 'GLOBAL.SENT_TO',
    SERVER_ERROR_NOT_AUTHORIZED = 'SERVER_ERROR_NOT_AUTHORIZED',
    SERVICE_UNAVAILABLE = 'GLOBAL.SERVICE_UNAVAILABLE',
    SETTINGS = 'GLOBAL.SETTINGS',
    SETTINGS_DESCRIPTION = 'CONNECTORS.SETTINGS_DESCRIPTION',
    SETUP = 'CONNECTORS.SETUP',
    SET_AS_SOURCE = 'LANGUAGES.SET_AS_SOURCE',
    SET_UP = 'GLOBAL.SET_UP',
    SEVERAL_MANDATORY_FIELDS_MISSING = 'GLOBAL.SEVERAL_MANDATORY_FIELDS_MISSING',
    SHARE = 'GLOBAL.SHARE',
    SHARED = 'GLOBAL.SHARED',
    SHARE_VIA_APP = 'GLOBAL.SHARE_VIA_APP',
    SHOW = 'SHOW',
    SHOW_ADVANCED_SETTINGS = 'GLOBAL.SHOW_ADVANCED_SETTINGS',
    SHOW_ALL = 'SHOW_All',
    SHOW_ARCHIVED = 'GLOBAL.SHOW_ARCHIVED',
    SHOW_AS = 'GLOBAL.SHOW_AS',
    SHOW_DETAILS = 'GLOBAL.SHOW_DETAILS',
    SHOW_FILTERS = 'FRONT.SEARCH.SHOW_FILTERS',
    SHOW_ISSUE = 'GLOBAL.SHOW_ISSUE',
    SHOW_LESS = 'GLOBAL.SHOW_LESS',
    SHOW_MESSAGE = 'GLOBAL.SHOW_MESSAGE',
    SHOW_MORE = 'GLOBAL.SHOW_MORE',
    SHOW_ONLY_VISIBLE_ITEMS = 'GLOBAL.SHOW_ONLY_VISIBLE_ITEMS',
    SHOW_SUGGESTIONS = 'GLOBAL.SHOW_SUGGESTIONS',
    SIGN_IN = 'LOGIN_CLASSIC_SIGN_IN',
    SIMPLE_DATE_FORMAT_COMPLETE = 'SIMPLE_DATE_FORMAT_COMPLETE',
    SITE = 'ADMIN_GAMIFICATION_LEADERBOARD_SCOPE_INSTANCE',
    SITES = 'GLOBAL.SITES',
    SITE_ADMINS = 'GLOBAL.SITE_ADMINS',
    SITE_GROUPS = 'FEED_GROUP_OTHERS',
    SITE_LANGUAGES = 'GLOBAL.SITE_LANGUAGES',
    SIZE = 'GLOBAL.SIZE',
    SKIP_LINKS = 'GLOBAL.SKIP_LINKS',
    /**
     * @deprecated use GLOBAL.SKIP_TO_CONTENT instead
     */
    SKIP_NAVIGATION = 'FRONT.HEADER.SKIP_NAVIGATION',
    SKIP_TO_ASK_AI = 'GLOBAL.SKIP_TO_ASK_AI',
    SKIP_TO_CONTENT = 'GLOBAL.SKIP_TO_CONTENT',
    SKIP_TO_NAVIGATION = 'GLOBAL.SKIP_TO_NAVIGATION',
    SLIDESHOW = 'FRONT.SETTINGS.VIEW_MODE.SLIDESHOW',
    SLIDE_NB = 'GLOBAL.SLIDE_NB',
    SLIDE_NB_OF_NB_TOTAL = 'GLOBAL.SLIDE_NB_OF_NB_TOTAL',
    SLUG = 'LOOKER_GLOBAL_SLUG',
    SMALL = 'GLOBAL.SMALL',
    SOCIAL = 'GLOBAL.SOCIAL',
    SOCIAL_ADVOCACY = 'ADMIN.NAV.SOCIAL_ADVOCACY',
    SOME_FILES_FAILED_TO_UPLOAD = 'GLOBAL.SOME_FILES_FAILED_TO_UPLOAD',
    SORTED_BY = 'GLOBAL.SORTED_BY',
    SORTING = 'GLOBAL.SORTING',
    SORT_ALPHABETICALLY_ASC = 'GLOBAL.SORT_ALPHABETICALLY_ASC',
    SORT_ALPHABETICALLY_DESC = 'GLOBAL.SORT_ALPHABETICALLY_DESC',
    SORT_BY = 'GLOBAL.SORT_BY',
    SORT_BY_ALPHABETIC_ORDER = 'GLOBAL.SORT_RULE',
    SORT_COMMENTS_ASC = 'GLOBAL.SORT_COMMENTS_ASC',
    SORT_COMMENTS_DESC = 'GLOBAL.SORT_COMMENTS_DESC',
    SORT_CRITERIA_ALPHABETICALLY_ASC = 'GLOBAL.SORT_CRITERIA_ALPHABETICALLY_ASC',
    SORT_CRITERIA_ALPHABETICALLY_DESC = 'GLOBAL.SORT_CRITERIA_ALPHABETICALLY_DESC',
    SORT_LATEST_UDPATE = 'GLOBAL.SORT_LATEST_UDPATE',
    SORT_LIKES_ASC = 'GLOBAL.SORT_LIKES_ASC',
    SORT_LIKES_DESC = 'GLOBAL.SORT_LIKES_DESC',
    SORT_MANUAL_ORDER = 'GLOBAL.SORT_MANUAL_ORDER',
    SORT_NEWEST = 'GLOBAL.SORT_NEWEST',
    SORT_OLDEST = 'GLOBAL.SORT_OLDEST',
    SORT_OLDEST_UPDATE = 'GLOBAL.SORT_OLDEST_UPDATE',
    SOURCE = 'GLOBAL.SOURCE',
    SOURCES = 'GLOBAL.SOURCES',
    SOURCE_LANGUAGE = 'LANGUAGES.SOURCE_LANGUAGE',
    SOURCE_LANGUAGE_DESCRIPTION = 'LANGUAGES.SOURCE_LANGUAGE_DESCRIPTION',
    SPACE = 'GLOBAL.SPACE',
    SPACES = 'GLOBAL.FEATURE_SPACES',
    SPEAKERS = 'GLOBAL.SPEAKERS',
    SPECIFIC_FILE_ENCODING = 'GLOBAL.SPECIFIC_FILE_ENCODING',
    START = 'GLOBAL.START',
    STARTING = 'GLOBAL.STARTING',
    START_DATE = 'START_DATE',
    START_TIME = 'START_TIME',
    START_WRITING = 'GLOBAL.START_WRITING',
    STATISTICS = 'GLOBAL.STATISTICS',
    STATUS = 'GLOBAL.STATUS',
    STATUS_CHANGED_FOR = 'GLOBAL.STATUS_CHANGED_FOR',
    STEP_OF_WIZARD = 'GLOBAL.STEP_OF_WIZARD',
    STYLES = 'GLOBAL.STYLES',
    SUBJECT = 'GLOBAL.SUBJECT',
    SUBMIT = 'GLOBAL.SUBMIT',
    SUBSCRIPTIONS = 'SOCIAL_PROFILE_SUBSCRIPTIONS',
    SUBTITLE = 'FRONT.SETTINGS.SUBTITLE',
    SUB_CATEGORY = 'GLOBAL.SUB_CATEGORY',
    SUCCESS = 'MICRO_APPS_RUNS.SUCCESS',
    SUGGESTION = 'GLOBAL.SUGGESTION',
    SUMMARY = 'COMMUNITY_DETAILS',
    SURVEYS = 'GLOBAL.SURVEYS',
    SWITCH_BACK_CURRENT_VIEW = 'GLOBAL.SWITCH_BACK_CURRENT_VIEW',
    SWITCH_TO_NEW_VIEW = 'GLOBAL.SWITCH_TO_NEW_VIEW',
    TAGS = 'GLOBAL.TAGS',
    TASKS = 'GLOBAL.TASKS',
    TEMPLATE = 'GLOBAL.TEMPLATE',
    TEMPLATES = 'GLOBAL.TEMPLATES',
    TEMPLATE_DELETE_CONFIRM_MESSAGE = 'GLOBAL.TEMPLATE_DELETE_CONFIRM_MESSAGE',
    TEMPLATE_DELETE_CONFIRM_MESSAGE_WITH_TITLE = 'GLOBAL.TEMPLATE_DELETE_CONFIRM_MESSAGE_WITH_TITLE',
    TEMPORALITY = 'EVENTS.PICKER_TEMPORALITY_LABEL',
    TEMPORALITY_FUTURE = 'FRONT.WIDGET_POST_LIST.SETTINGS.FUTURE_EVENTS',
    TEMPORALITY_ONGOING = 'FRONT.WIDGET_POST_LIST.SETTINGS.ONGOING_EVENTS',
    TEMPORALITY_PAST = 'FRONT.WIDGET_POST_LIST.SETTINGS.PAST_EVENTS',
    TERMS_AND_CONDITIONS = 'GLOBAL.TERMS_AND_CONDITIONS',
    TEST_KO = 'GLOBAL.TEST_KO',
    TEST_OK = 'GLOBAL.TEST_OK',
    TEXT = 'GLOBAL.TEXT',
    TEXT_COLOR = 'FRONT.TEXT_EDITOR.HEADINGS.COLOR_SELECTION',
    THEN = 'GLOBAL.THEN',
    THERE_ARE_NO_INSIGHTS = 'GLOBAL.THERE_ARE_NO_INSIGHTS',
    THIS_LINK = 'GLOBAL.THIS_LINK',
    THUMBNAIL = 'GLOBAL.THUMBNAIL',
    TILES = 'GLOBAL.TILES',
    TIME = 'TIME',
    TIMEZONE = 'GLOBAL.TIMEZONE',
    TIME_APPROXIMATELY = 'GLOBAL.TIME_APPROXIMATELY',
    TIME_FORMAT_SHORT = 'GLOBAL.TIME_FORMAT_SHORT',
    TITLE = 'GLOBAL.TITLE',
    TITLE_CONTAINS_ONLY_SPACES = 'GLOBAL.TITLE_CONTAINS_ONLY_SPACES',
    TITLE_MANDATORY = 'GLOBAL.TITLE_MANDATORY',
    TO = 'GLOBAL.TO',
    TODAY = 'GLOBAL.TODAY',
    TOGGLE = 'GLOBAL.TOGGLE',
    TOGGLE_ALL = 'TOGGLE_ALL',
    TOGGLE_FILTER_OPTIONS = 'GLOBAL.TOGGLE_FILTER_OPTIONS',
    TOKEN_URL = 'CONNECTORS.TOKEN_URI',
    TOKEN_URL_HELPER = 'CONNECTORS.TOKEN_URI_HELPER',
    TOOL = 'LOOKER_AGENT_TOOL_FILTER',
    TOOLBOX = 'GLOBAL.TOOLBOX',
    TOOLBOXES = 'GLOBAL.TOOLBOXES',
    TOPICS = 'GLOBAL.TOPICS',
    TOTAL_VIEWS = 'GLOBAL.TOTAL_VIEWS',
    TO_ACKNOWLEDGE = 'GLOBAL.TO_ACKNOWLEDGE',
    TO_COMMENT = 'GLOBAL.TO_COMMENT',
    TO_COMPLETE = 'GLOBAL.TO_COMPLETE',
    TO_DO = 'GLOBAL.TO_DO',
    TO_NB_SUBJECT = 'GLOBAL.TO_NB_SUBJECT',
    TO_OPEN = 'GLOBAL.TO_OPEN',
    TO_PERSON = 'GLOBAL.TO_PERSON',
    TO_VIEW = 'GLOBAL.TO_VIEW',
    TRAINING = 'GLOBAL.TRAINING',
    TRAINING_COURSES = 'LEARNING.TRAINING_COURSES',
    TRANSLATE = 'GLOBAL.TRANSLATE',
    TRANSLATE_WITH_AI = 'GLOBAL.TRANSLATE_WITH_AI',
    TRANSLATION_MANAGER = 'LANGUAGES.TRANSLATION_MANAGER',
    TRY_AGAIN = 'GLOBAL.TRY_AGAIN',
    TRY_ANOTHER_FILTER = 'GLOBAL.TRY_ANOTHER_FILTER',
    TRY_ANOTHER_QUERY = 'GLOBAL.TRY_ANOTHER_QUERY',
    TRY_ANOTHER_QUERY_OR_FILTER = 'GLOBAL.TRY_ANOTHER_QUERY_OR_FILTER',
    TRY_BETA = 'GLOBAL.TRY_BETA',
    TRY_NEW_PAGE = 'GLOBAL.TRY_NEW_PAGE',
    TRY_RELOAD = 'GLOBAL.TRY_RELOAD',
    TUTORIAL = 'GLOBAL.TUTORIAL',
    TUTORIALS = 'TUTORIAL_PLURAL',
    TYPE = 'GLOBAL.TYPE',
    TYPES = 'MS_TYPES',
    UNABLE_TO_SAVE = 'GLOBAL.UNABLE_TO_SAVE',
    UNARCHIVE = 'CONTENT_SET_TO_UNARCHIVE',
    UNARCHIVED = 'GLOBAL.UNARCHIVED',
    UNAVAILABLE_COMMUNITY = 'GLOBAL.UNAVAILABLE_COMMUNITY',
    UNAVAILABLE_CONTENT = 'GLOBAL.UNAVAILABLE_CONTENT',
    UNAVAILABLE_FEATURE_IE = 'FRONT.WARNING.UNAVAILABLE_FEATURE_IE',
    UNAVAILABLE_GROUP = 'GLOBAL.UNAVAILABLE_GROUP',
    UNDATED = 'GLOBAL.UNDATED',
    UNDEFINED = 'GLOBAL.UNDEFINED',
    UNFOLLOW = 'GLOBAL.UNFOLLOW',
    UNIT = 'GLOBAL.UNIT',
    UNKNOWN = 'FRONT.COMMUNITY.POST_EVENT.ATTENDEES_UNKNOWN',
    UNKNOWN_USER = 'UNKNOWN_USER',
    UNNAMED = 'GLOBAL.UNNAMED',
    UNPUBLISH = 'CONTENT_SET_TO_DRAFT',
    UNPUBLISHED = 'CONTENT.STATUS_DRAFT',
    UNSAVED_MODIFICATIONS = 'GLOBAL.DISCARD_UNSAVED_CHANGES_DIALOG.TITLE',
    UNSAVED_MODIFICATIONS_DESCRIPTION = 'GLOBAL.DISCARD_UNSAVED_CHANGES_DIALOG.DESCRIPTION',
    UNTITLED = 'GLOBAL.UNTITLED',
    UNVERIFIED = 'GLOBAL.UNVERIFIED',
    UPDATE = 'GLOBAL.UPDATE',
    UPDATED = 'GLOBAL.UPDATED',
    UPDATED_AT = 'UPDATED_AT',
    UPDATED_BY = 'GLOBAL.UPDATED_BY',
    UPDATED_DATE = 'UPDATED_DATE',
    UPDATED_ON = 'GLOBAL.UPDATED_ON',
    UPDATED_ON_DATE = 'CONTENT_ADMIN.UPDATE_ON_DATE',
    UPDATES = 'GLOBAL.UPDATES',
    UPDATES_STATUS = 'GLOBAL.UPDATES_STATUS',
    UPGRADE = 'GLOBAL.UPGRADE',
    UPLOADING_FILE = 'GLOBAL.UPLOADING_FILE',
    UPLOAD_AN_IMAGE = 'GLOBAL.UPLOAD_AN_IMAGE',
    UPLOAD_FAILED = 'GLOBAL.ERROR.UPLOAD_FAILED',
    UPLOAD_FILE = 'ADMIN.NANNY.UPLOAD_FILE',
    UPLOAD_FILE_RESTRICTION = 'GLOBAL.UPLOAD_FILE_RESTRICTION',
    UPLOAD_LOGO = 'ADMIN_INSTANCE_SETTINGS_LOGO_UPLOAD',
    URL = 'GLOBAL.URL',
    URL_ERROR = 'GLOBAL.URL_ERROR',
    URL_FIELD_ERROR_MESSAGE = 'ADMIN.MOBILE.NAVIGATION.EXTERNAL_LINK.URL_FIELD.ERROR_MESSAGE',
    URL_FIELD_LABEL = 'ADMIN.MOBILE.NAVIGATION.EXTERNAL_LINK.URL_FIELD.LABEL',
    URL_HELPER = 'GLOBAL.URL_HELPER',
    USED = 'GLOBAL.USED',
    USED_BY = 'GLOBAL.USED_BY',
    USER = 'GLOBAL.USER',
    USERNAME = 'GLOBAL.USERNAME',
    USERS = 'GLOBAL.USERS',
    USERS_COUNT = 'GLOBAL.USERS_COUNT',
    USER_ADDED_SUCCESS_MESSAGE = 'USER_DIRECTORY_ADD_SUCCESS',
    USER_CONTENT_ACCESS = 'LANGUAGES.USER_CONTENT_ACCESS',
    USER_DIRECTORIES = 'USER_DIRECTORY_PLURAL',
    USER_DIRECTORY = 'GLOBAL.USER_DIRECTORY',
    USER_ENGAGEMENT = 'GLOBAL.USER_ENGAGEMENT',
    USER_PROFILE = 'GLOBAL.USER_PROFIL',
    USER_PROFILE_FIELDS_LABEL = 'ADMIN.SEARCH_SETTINGS.USER_PROFILE_FIELDS_LABEL',
    USE_DEFAULT_VALUES = 'USE_DEFAULT_VALUES',
    USE_VALUE = 'GLOBAL.USE_VALUE',
    VALUE = 'GLOBAL.VALUE',
    VALUES = 'GLOBAL.VALUES',
    VERIFIED = 'GLOBAL.VERIFIED',
    VERSIONS = 'LANGUAGES.VERSIONS',
    VIDEO = 'GLOBAL.VIDEO',
    VIDEOS = 'GLOBAL.VIDEOS',
    VIDEOS_PLAYLISTS = 'GLOBAL.VIDEOS_PLAYLISTS',
    VIDEO_PLAYLIST = 'SEARCH_PLUS_VIDEO-PLAYLIST/VIDEO_TAB',
    VIEW = 'VIEW',
    VIEWED = 'GLOBAL.VIEWED',
    VIEWS = 'GLOBAL.VIEWS',
    VIEW_ALL = 'VIEW_ALL',
    VIEW_HOMEPAGE = 'ADMIN.VIEW_HOMEPAGE',
    VIEW_USER_PROFILE = 'GLOBAL.VIEW_USER_PROFILE',
    VISIBILITY = 'GLOBAL.VISIBILITY',
    VISIBLE_BY = 'VISIBLE_BY',
    WARNING_DELETE = 'WREX_CORE.WARNING_DELETE',
    WARNING_UNSAVED_CHANGES = 'GLOBAL.WARNING_UNSAVED_CHANGES',
    WEBSITE = 'GLOBAL.WEBSITE',
    WEB_AND_MOBILE_APP = 'GLOBAL.WEB_AND_MOBILE_APP',
    WEEKS = 'GLOBAL.WEEKS',
    WIDGET = 'GLOBAL.WIDGET',
    WIP = 'GLOBAL.WORK_IN_PROGRESS',
    WITHDRAW = 'GLOBAL.WITHDRAW',
    WORKFLOW = 'GLOBAL.WORKFLOW',
    WORKFLOWS = 'GLOBAL.WORKFLOWS',
    WRITE_YOUR_TEXT_HERE = 'FRONT.ARTICLES.DIALOG.CONTENT_PLACEHOLDER',
    WRONG_FORMAT_FILE = 'GLOBAL.WRONG_FORMAT_FILE',
    X_FILES_ONLY = 'GLOBAL.X_FILES_ONLY',
    YEAR = 'GLOBAL.YEAR',
    YEARS = 'GLOBAL.YEARS',
    YES = 'GLOBAL.YES',
    YESTERDAY = 'GLOBAL.YESTERDAY',
    ZENDESK = 'SEARCH_PLUS_ZENDESK_TAB',
    ZOOM_IN = 'GLOBAL.ZOOM_IN',
    ZOOM_OUT = 'GLOBAL.ZOOM_OUT',
}
export const getServerError = (serverError: string) => `SERVER_ERROR_${serverError}`;
